import React, { useContext } from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { Formik, Form } from 'formik';
import { Button, Card, Col, message, Row } from 'antd';
import Item from '../../../components/Form/Item';
import { Link, useHistory } from 'react-router-dom';
import PassportSelect from './PassportSelect';
import Detail from './Detail';
import PassportDetail from './PassportDetail';
import { newTrainingDataSchema } from './schema';
import History from '../History';
import axios from '../../../util/Api';
import { ParamsContext } from '../../Context/ParamsContext';
import Scan from './Scan';

const Index = ({ passport }) => {
  const history = useHistory();
  const { id } = useContext(ParamsContext);

  return (
    <Auxiliary>
      <Formik
        initialValues={{
          passport: {
            id: id ? id : undefined
          },
          date: {
            start: undefined,
            end: undefined,
          },
          type: undefined,
          field: {
            category: undefined,
            title: undefined
          },
        }}
        validationSchema={newTrainingDataSchema}
        onSubmit={values => {
          const url = `/training/create`;
          axios.post(url, { ...values }).then(resp => {
            if (resp.data.success) {
              message.success("Data training baru telah berhasil disimpan");
              history.push(`/training`);
            } else {
              message.error("Gagal menyimpan data training");
            }
          }).catch(err => {
            console.log(err);
            message.error("Gagal menyimpan data training. Silakan reload dan coba kembali");
          });
        }}
      >
        {(formik) => {
          return (
            <Form>
              <Row>
                <Col md={16} xs={24}>
                  <Card className="gx-card">
                    <Item name="Identitas Diri">
                      <PassportSelect />
                    </Item>

                    {formik.values.passport.id ? <PassportDetail /> : null}

                    {formik.values.passport.id ? <Detail /> : null}

                    <Row>
                      <Col span={6}></Col>
                      <Col span={18}>
                        <Button type="primary" htmlType="submit" loading={formik.isSubmitting}>Tambah Data Training</Button>
                        <Link to={id ? `/passport/detail?id=${id}` : `/training`}><Button type="default">Batal</Button></Link>
                      </Col>
                    </Row>

                  </Card>
                </Col>
                <Col md={8} xs={24}>
                  <Scan />
                </Col>
              </Row>
              {formik.values.passport.id ? (
                <History id={formik.values.passport.id} />
              ) : null}
            </Form>
          );
        }}
      </Formik>
    </Auxiliary>
  );
}

export default Index;